import React from 'react'
import { Row, Col } from 'reactstrap'
import { StaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import { prop } from 'ramda'
import { Placeholder, ContainerLg } from '../../GlobalStyles'
import styled from 'styled-components'

export const Heading = styled.div`
  font-family: ${p => p.font || p.theme.fonts.Lato};
  font-weight: 600;
  line-height: 1;
  margin-bottom: 20px;
  font-size: 28px;
  color: ${p => p.color || p.theme.colors.navy};
  @media screen and (min-width: 1025px) {
    font-size: 54px;
    margin-bottom: 12px;
  }
  span {
    font-size: 36px;
    @media screen and (min-width: 1025px) {
      font-size: 70px;
    }
  }
`
export const Paragraph = styled.div`
  font-size: 16px;
  color: ${p => p.color || p.theme.colors.darkGray};
  @media screen and (min-width: 1025px) {
    font-size: 28px;
    margin-bottom: 12px;
  }
`

export const IntroContainer = styled(ContainerLg)`
  background-color: #efe9dd;
  padding-top: 30px;
  padding-bottom: 30px;
`

export const IntroImage = styled(Img)`
  box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.2);
  max-width: 100%;
  margin: 0 auto 40px;
  display: block;
  @media screen and (min-width: 1025px) {
    margin: 0 auto;
    max-width: 80%;
  }
`

const IntroSection = props => (
  <StaticQuery
    query={graphql`
      query {
        IntroImage: file(
          relativePath: { eq: "NextSteps/formPerfectProfile.jpg" }
        ) {
          ...optimizedImage
          publicURL
        }
      }
    `}
    render={data => (
      <IntroContainer id='intro'>
        <Row>
          <Col md={{ size: 3 }} lg={{ size: 4 }}>
            {prop('IntroImage', data) ? (
              <a href={data.IntroImage.publicURL}>
                <IntroImage fluid={data.IntroImage.childImageSharp.fluid} />
              </a>
            ) : (
              <Placeholder />
            )}
          </Col>
          <Col md={{ size: 7 }} lg={{ size: 8 }}>
            <Heading>
              THE PERFECT PROFILE CAPTURES <span>YOU.</span>
            </Heading>
            <Paragraph>
              We’ve designed the profile form to easily capture all of the key
              information that prospects look for when searching for a coach.
              Make your profile stand out and complete as many fields as
              possible. Here are some quick tips before you log in to complete
              your profile:
            </Paragraph>
          </Col>
        </Row>
      </IntroContainer>
    )}
  />
)

export default IntroSection
